import React, { Component } from 'react'
import _ from 'lodash';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { AutoComplete as MuiAutoComplete } from 'material-ui'
import {searchCountries, searchOffers, searchPackages} from '../restClient'

const packagesDataSourceConfig = {
  text: 'productIdentifier',
  value: 'productIdentifier',
}

export function PackageAutoComplete({ record, node, ...props }) {
  return (
    <AutoComplete
      name={'newPackage'}
      dataSourceConfig={packagesDataSourceConfig}
      getData={(searchText) => searchPackages(searchText, record.countryCode, record.platform)}
      record={record}
      autoCompleteProps={{ hintText: 'Add new package' }}
      onPrefill={async () => ({
        dataSource: await searchPackages('', record.countryCode, record.platform),
        searchText: '',
      })}
      {...props}
    />
  )
}

const countriesDataSourceConfig = {
  text: 'title',
  value: 'code',
}

export function CountriesAutoComplete(props) {
  const { source: field = 'countryCode' } = props
  const onNewRequest = (record) => {
    const value = typeof record === 'string' ? record : record.code
    props.setFilters({...props.filterValues, [field]: value})
  }

  return (
      <AutoComplete
          name={field}
          isTopPosition={false}
          filter={() => true}
          dataSourceConfig={countriesDataSourceConfig}
          getData={(searchText) => {
            if (!searchText) {
              const {filterValues} = props
              delete filterValues[field]
              props.setFilters(filterValues)
            }
            return searchCountries(searchText)
          }}
          autoCompleteProps={{
            hintText: 'Select a country',
            anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
            textFieldStyle: { width: 300 }
          }}
          {...props}
          onNewRequest={(record) => onNewRequest(record)}
          onPrefill={async () => {
            let dataSource = []
            const value = props.filterValues[field] || ''
            let searchText = value

            if (value) {
              dataSource = await searchCountries(value)
              const country = dataSource.find(({code}) => searchText === code)

              if (country) {
                searchText = `${country.name} (${country.code})`
              }
            }
            return {
              dataSource,
              searchText,
            }
          }}
      />
  )
}

const offerDataSourceConfig = {
  text: 'title',
  value: '_id',
}

export function OfferAutoComplete({ record, node, ...props }) {
  return (
    <AutoComplete
      name="offer"
      dataSourceConfig={offerDataSourceConfig}
      getData={(searchText) => searchOffers(searchText)}
      record={record}
      autoCompleteProps={{
        hintText: 'Add or edit offer',
        floatingLabelText: 'Offer Linking',
        style: { height: 50, margin: '-17px 0 0 10px' },
      }}
      onPrefill={async () => {
        const dataSource = await searchOffers('')
        const fullOffer = dataSource.find(({ _id }) => node.offer === _id)
        return {
          dataSource,
          searchText: fullOffer ? fullOffer.title : '',
        }
      }}
      defaultValue={node.offer}
      {...props}
    />
  )
}

const dropdownHeight = 300

class AutoComplete extends Component {
  initial = true

  constructor(props) {
    super(props)
    const { onPrefill, isTopPosition = true } = props
    this.state = {
      dataSource: [],
      searchText: '',
      isTopPosition,
    }
    if (onPrefill) {
      onPrefill().then((state) => state && this.setState(state))
    }
  }

  search = (searchText) => {
    this.props.getData(searchText)
      .then((json) => {
        this.setState({ dataSource: json })
      })
      .catch((ex) => {
        console.log('parsing failed', ex)
      })
  }

  componentWillUnmount() {
    this.debouncedSearch.cancel();
  }

  debouncedSearch = _.debounce((searchText) => {
    this.search(searchText)
  }, 1000)

  onUpdateInput = (searchText) => {
    this.initial = false
    this.setState({ searchText })
    this.debouncedSearch(searchText)
  }

  onRequest = (request) => {
    if (this.props.onNewRequest(request)) {
      this.onUpdateInput('')
    }
  }

  render() {
    const {
      name,
      dataSourceConfig,
      autoCompleteProps: {
        textFieldStyle: { width = 150, ...textFieldStyle } = {},
        listStyle = {},
        menuStyle = {},
        style = {},
        ...restProps
      },
      filter = (searchText, key) => this.initial || key.indexOf(searchText) !== -1
    } = this.props
    const { searchText, dataSource, isTopPosition } = this.state
    const topPositioningProps = {
      anchorOrigin: { vertical: 'top', horizontal: 'left' },
      targetOrigin: { vertical: 'bottom', horizontal: 'left'},
    }

    return (
      <MuiThemeProvider muiTheme={getMuiTheme()}>
        <MuiAutoComplete
          {...restProps}
          style={{ width, overflow: 'visible', ...style }}
          textFieldStyle={{ width, ...textFieldStyle }}
          listStyle={{ maxHeight: dropdownHeight, width: 300, ...listStyle }}
          menuStyle={{ maxHeight: dropdownHeight, width: 300, ...menuStyle }}
          name={name}
          searchText={searchText}
          onNewRequest={this.onRequest}
          dataSource={dataSource}
          onUpdateInput={this.onUpdateInput}
          dataSourceConfig={dataSourceConfig}
          filter={filter}
          openOnFocus
          {...isTopPosition ? topPositioningProps : {}}
        />
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/autoComplete.js